import { HP, pt } from '../enemy-parts';
/* ============================================================
   家族 WING 翼 —— 浮空
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     KRÄHE   amb 鴉　飛行・俯衝
     FALKE   red 隼　俯衝・撞擊
     SCHWARM vio 投彈群　空投・範圍
     HORCHER azu 監聽者　空中・增益
     MOTTE   vio 蛾　深層・不規則飛行

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var WING = [
  /* ─ 7 ─────────────────────────────────────────────────────────
     KRÄHE 鴉 —— 唯一在別的高度的敵人。辨識靠 Y 軸，不靠外框。
     下垂的兩根爪是給俯視鏡頭用的：從上面看它才有「腳」。 */
  {
    id:'krahe', fam:'wing', code:'KRÄHE', zh:'鴉', role:'飛行・俯衝', tint:'amb',
    sil:'浮空箭頭＋垂爪', h:2.10, w:1.30, wt:1.5, fly:1.72,
    spd:3.6, turn:2.0, gait:1.0, rng:4.2, tTel:0.45, tAtk:0.55, tRec:0.90,
    q0:{wg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'截擊', q:{wg:0.82}, sp:1.35, sc:0.88},
          {n:'掛彈', q:{wg:1.28}, sp:0.80, sc:1.14}],
    parts:[
      pt('bev','dark', [0.36,0.32,0.98],[0,1.72,0]),
      pt('box','armor',[0.94,0.07,0.44],[ 0.56,1.76,-0.10],[0,-0.42,-0.26], function(P,o){
          P.sx *= o.q.wg; P.x *= o.q.wg; P.rz -= o.bank; }),
      pt('box','armor',[0.94,0.07,0.44],[-0.56,1.76,-0.10],[0, 0.42, 0.26], function(P,o){
          P.sx *= o.q.wg; P.x *= o.q.wg; P.rz -= o.bank; }),
      pt('cone','trim',[0.16,0.48,0.16],[ 0.18,1.46,0.14],[Math.PI,0,0.10], function(P,o){
          P.rx += 0.5*o.atk; }),
      pt('cone','trim',[0.16,0.48,0.16],[-0.18,1.46,0.14],[Math.PI,0,-0.10], function(P,o){
          P.rx += 0.5*o.atk; }),
      pt('cone','glow',[0.26,0.34,0.26],[0,1.72,-0.56],[-HP,0,0], function(P,o){
          var k = 1 + 1.6*o.atk + 0.5*o.tel;
          P.sx *= k; P.sy *= 0.6+k*0.7; P.sz *= k; })
    ],
    ex:[ pt('box','armorE',[0.30,0.14,0.70],[0,1.92,-0.08],[0.16,0,0]),
         pt('cyl','armorE',[0.18,0.52,0.18],[ 0.44,1.58,-0.04],[0,0,0.2]),
         pt('cyl','armorE',[0.18,0.52,0.18],[-0.44,1.58,-0.04],[0,0,-0.2]),
         pt('cone','armorE',[0.20,0.44,0.20],[0,1.72,0.62],[1.4,0,0]),
         pt('box','glowE',[0.60,0.05,0.05],[0,1.86,0.10]) ],
    pose:function(o){
      o.fly = 1;
      o.bank = 0.30*Math.sin(o.t*0.9) - o.atk*0.20;
      o.ry = 0.16*Math.sin(o.t*1.6) - o.atk*1.05 + o.tel*0.22;
      o.rp = -0.06 - o.tel*0.10 + o.atk*0.52;
      o.rr = o.bank;
      o.rz = o.atk*1.30;
    }
  },
  /* ── 家族 WING 翼 ── 浮空。辨識靠 Y 軸與影子距離。amb 是 KRÄHE。 */
  {
    id:'falke', fam:'wing', code:'FALKE', zh:'隼', role:'俯衝・撞擊', tint:'red',
    sil:'浮空箭頭＋前錐', h:1.94, w:1.16, fly:1.50, wt:1.4,
    spd:3.4, turn:2.8, gait:1.0, rng:2.6, tTel:0.40, tAtk:0.48, tRec:0.80,
    q0:{wg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'截擊', q:{wg:0.82}, sp:1.42, sc:0.86},
          {n:'重隼', q:{wg:1.26}, sp:0.80, sc:1.16}],
    parts:[
      pt('bev','dark', [0.34,0.28,0.94],[0,1.50,0],[0.10,0,0]),
      pt('cone','armor',[0.28,0.56,0.28],[0,1.50,0.66],[HP,0,0], function(P,o){
          P.z += o.atk*0.20; }),
      pt('box','armor',[0.86,0.07,0.44],[ 0.46,1.50,-0.16],[0,-0.42,-0.22], function(P,o){
          P.sx *= o.q.wg; P.ry += o.tel*0.16; }),
      pt('box','armor',[0.86,0.07,0.44],[-0.46,1.50,-0.16],[0, 0.42, 0.22], function(P,o){
          P.sx *= o.q.wg; P.ry -= o.tel*0.16; }),
      pt('box','glow', [0.10,0.10,0.46],[0,1.44,0.16],null, function(P,o){
          var k = 1 + 1.8*o.tel + 2.2*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.18,0.40,0.18],[0,1.50,-0.56],[-HP,0,0])
    ],
    ex:[ pt('box','armorE',[0.30,0.30,0.36],[0,1.68,-0.20],[0.2,0,0]),
         pt('cone','glowE',[0.16,0.28,0.16],[0,1.50,0.92],[HP,0,0]) ],
    pose:function(o){
      o.ry = 0.14*Math.sin(o.t*1.4) - 1.02*o.atk*(2-o.atk);
      o.rp = -0.10 - o.tel*0.24 + o.atk*0.70;
      o.rr = 0.34*Math.sin(o.t*0.8)*(1-o.atk);
      o.rz = o.atk*2.6;
    }
  },
  {
    id:'schwarm', fam:'wing', code:'SCHWARM', zh:'投彈群', role:'空投・範圍', tint:'vio',
    sil:'浮空箭頭＋雙掛彈', h:2.24, w:1.44, fly:1.86, wt:0.9,
    spd:1.9, turn:1.8, gait:1.0, rng:5.4, tTel:0.90, tAtk:0.40, tRec:1.10,
    q0:{wg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'快投', q:{wg:0.84}, sp:1.34, sc:0.88},
          {n:'滿掛', q:{wg:1.30}, sp:0.76, sc:1.16}],
    parts:[
      pt('bev','dark', [0.44,0.34,0.86],[0,1.86,0],[0.06,0,0]),
      pt('box','armor',[1.10,0.08,0.50],[ 0.60,1.86,-0.06],[0,-0.30,-0.16], function(P,o){
          P.sx *= o.q.wg; }),
      pt('box','armor',[1.10,0.08,0.50],[-0.60,1.86,-0.06],[0, 0.30, 0.16], function(P,o){
          P.sx *= o.q.wg; }),
      pt('oct','glow', [0.32,0.32,0.32],[ 0.54,1.66,-0.02],null, function(P,o){
          P.y -= o.atk*0.9; var k = 1 + 0.9*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('oct','glow', [0.32,0.32,0.32],[-0.54,1.66,-0.02],null, function(P,o){
          P.y -= o.atk*0.9; var k = 1 + 0.9*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cyl','trim', [0.26,0.42,0.26],[0,1.86,-0.60],[HP,0,0])
    ],
    ex:[ pt('box','armorE',[0.40,0.30,0.42],[0,2.10,-0.10],[0.16,0,0]),
         pt('oct','glowE', [0.26,0.26,0.26],[0,1.62,0.34]) ],
    pose:function(o){
      o.ry = 0.16*Math.sin(o.t*1.1) + 0.20*o.tel;
      o.rp = -0.05 + o.tel*0.10;
      o.rr = 0.20*Math.sin(o.t*0.7);
    }
  },
  {
    id:'horcher', fam:'wing', code:'HORCHER', zh:'監聽者', role:'空中・增益', tint:'azu',
    sil:'浮空＋水平雷達盤', h:2.42, w:1.62, fly:2.00, wt:0.4,
    spd:1.3, turn:1.4, gait:1.0, rng:8.5, tTel:1.15, tAtk:0.60, tRec:1.35,
    q0:{ds:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'輕盤', q:{ds:0.82}, sp:1.40, sc:0.88},
          {n:'廣域', q:{ds:1.34}, sp:0.68, sc:1.14}],
    parts:[
      pt('oct','dark', [0.66,0.56,0.78],[0,2.00,0]),
      pt('tor','armor',[1.58,1.58,0.30],[0,2.22,0],[HP,0,0], function(P,o){
          var k = o.q.ds*(1 + 0.24*o.tel); P.sx*=k; P.sy*=k; P.rz += o.t*(0.8 + 4.0*o.tel); }),
      pt('box','armor',[1.22,0.06,0.34],[ 0.66,2.00,-0.08],[0,-0.24,-0.14], function(P,o){
          P.sx *= o.q.ds; }),
      pt('box','armor',[1.22,0.06,0.34],[-0.66,2.00,-0.08],[0, 0.24, 0.14], function(P,o){
          P.sx *= o.q.ds; }),
      pt('oct','glow', [0.28,0.28,0.28],[0,1.66,0.10],null, function(P,o){
          P.y -= 0.06*Math.sin(o.t*2.0);
          var k = 1 + 1.4*o.tel + 1.4*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cyl','trim', [0.20,0.34,0.20],[0,2.20,0])
    ],
    ex:[ pt('tor','glowE',[1.86,1.86,0.20],[0,2.10,0],[HP,0,0], function(P,o){ P.rz -= o.t*1.6; }),
         pt('box','armorE',[0.34,0.26,0.40],[0,2.00,-0.44],[0.2,0,0]) ],
    pose:function(o){
      o.ry = 0.12*Math.sin(o.t*0.9);
      o.rp = -0.03;
      o.rr = 0.10*Math.sin(o.t*0.6);
    }
  },
  {
    id:'motte', fam:'wing', deep:1, code:'MOTTE', zh:'蛾', role:'深層・不規則飛行', tint:'vio',
    sil:'浮空＋一大一小的翼', h:2.10, w:1.52, fly:1.62, wt:1.0,
    spd:2.2, turn:2.4, gait:1.0, rng:4.0, tTel:0.60, tAtk:0.42, tRec:0.90,
    q0:{wg:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'散翅', q:{wg:0.82}, sp:1.42, sc:0.88},
          {n:'巨翅', q:{wg:1.34}, sp:0.78, sc:1.16}],
    parts:[
      pt('bev','dark',[0.40,0.34,0.80],[0,1.62,0],[0.08,0,0]),
      pt('box','armor',[1.04,0.07,0.56],[ 0.62,1.68,-0.06],[0,-0.34,-0.26], function(P,o){
          P.sx *= o.q.wg; P.rz -= 0.34*Math.sin(o.t*7 + o.mv*4); }),
      pt('box','armor',[0.62,0.07,0.40],[-0.40,1.56, 0.02],[0, 0.30, 0.34], function(P,o){
          P.sx *= o.q.wg; P.rz += 0.44*Math.sin(o.t*7.6 + 1); }),
      pt('oct','void',[0.44,0.44,0.44],[0.06,1.44,0.10]),
      pt('tor','glow',[0.66,0.66,0.40],[0.06,1.44,0.10],[HP,0.4,0], function(P,o){
          P.rz += o.t*1.3; var k = 1 + 1.2*o.tel + 1.8*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cone','trim',[0.20,0.52,0.20],[0.02,1.62,-0.52],[-HP,0,0.2])
    ],
    ex:[ pt('box','armorE',[0.30,0.26,0.34],[0.10,1.84,-0.14],[0.2,0,0.2]),
         pt('oct','glowE',[0.18,0.18,0.18],[-0.34,1.72,0.16]) ],
    pose:function(o){ o.ry = 0.22*Math.sin(o.t*2.3) + 0.12*Math.sin(o.t*3.7) - 0.70*o.atk;
      o.rp = -0.06 - o.tel*0.16 + o.atk*0.42;
      o.rr = 0.30*Math.sin(o.t*1.9) + 0.10; o.rz = o.atk*1.5; }
  }
];
